<template>
	<v-card>
		<v-card-title>
			<v-spacer />
			<v-spacer />
			<v-text-field
				v-model="lookingFor"
				append-icon="mdi-magnify"
				label="חיפוש"
				single-line
				hide-details
			/>
		</v-card-title>
		<v-data-table
			:headers="headers"
			:items="subscriptions"
			:loading="loading"
			class="elevation-1"
			:search="lookingFor"
		>
			<v-progress-linear
				slot="progress"
				color="blue"
				indeterminate
			/>
			<template #item.project.redirect="{item}">
				<a
					v-if="item.project.show_redirect"
					:href="item.redirectUrl"
				>מעבר ל {{ item.project.subject }}</a>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>
import { types } from "src/store/modules/Subscription.module";

export default {
	name: "PurchaseHistory",
	data () {
		return {
			loading: false,
			headers: [
				{
					text: "שם פרויקט",
					value: "project.subject",
				},
				{
					text: "שם תכנית",
					value: "plan.description",
				},
				{
					text: "מחיר",
					value: "final_price"
					,
				},
				{
					text: "תאריך רכישה",
					value: "purchased_at",
				},
				{
					text: "קישור לפרויקט",
					value: "project.redirect",
				},
			],
			lookingFor: null,
			showDialog: false,
		};
	},
	computed: {
		user () {
			return this.$store.state.AuthModule.user;
		},
		subscriptions () {
			return this.$store.state.SubscriptionModule.subscriptions.map((subscription) => {
				const purchase = subscription.purchase;
				if (purchase) {
					subscription.final_price = purchase.sum;
				} else {
					subscription.final_price = "חינם";
				}
				return subscription;
			});
		},
	},
	async created () {
		this.loading = true;
		try {
			await this.$store.dispatch(types.FETCH_USER, this.user.id);
		} finally {
			this.loading = false;
		}
	},
};
</script>

<style scoped>

</style>
